module.exports = __webpack_public_path__ + "static/media/ic-tune-gray-big.b48dc1b3.svg";